var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_cof.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_cof.js
// module chunks = 168707334958949